var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#183C73",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 615 c-32 -31 -31 -50 0 -81 19 -18 31 -23 48 -19 53 16 69 64 33 100 -31 31 -50 32 -81 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 575 c0 -13 28 -15 195 -15 167 0 195 2 195 15 0 13 -28 15 -195 15 -167 0 -195 -2 -195 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 360 c-11 -11 -20 -29 -20 -40 0 -42 62 -75 96 -52 24 16 35 51 23 75 -23 43 -66 50 -99 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 320 c0 -19 7 -20 195 -20 188 0 195 1 195 20 0 19 -7 20 -195 20 -188 0 -195 -1 -195 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 106 c-31 -31 -32 -50 0 -81 31 -32 50 -31 81 0 36 36 20 84 -33 100 -17 4 -29 -1 -48 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 65 c0 -13 28 -15 195 -15 167 0 195 2 195 15 0 13 -28 15 -195 15 -167 0 -195 -2 -195 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToc);
export default __webpack_public_path__ + "static/media/toc.f6fe1d98444e686bdeff2beec21f5a9e.svg";
export { ForwardRef as ReactComponent };